import React, { useContext } from 'react';
import { Button } from '@mui/material';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import { makeStyles } from '@mui/styles';
import { TypeAnimation } from 'react-type-animation';
import './Landing.css';
import { ThemeContext } from '../../contexts/ThemeContext';
import { headerData } from '../../data/headerData';

function Landing() {
    const { theme, drawerOpen } = useContext(ThemeContext);

    const useStyles = makeStyles((t) => ({
        resumeBtn: {
            backgroundColor:  `theme.primary !important`,
            // color: theme.secondary,
            borderRadius: '0px !important',
            textTransform: 'inherit !important',
            textDecoration: 'none !important',
            width: '150px !important',
            height: '50px !important',
            fontSize: '1rem !important',
            fontWeight: '500 !important',
            fontFamily: 'var(--primaryFont)',
            border: `1px solid ${theme.fourthly} !important`,
             transition: '250ms ease-in-out',
            '&:hover': {
                transform: 'scale(1.05)',
                backgroundColor: `theme.tertiary !important`,
                color: `theme.primary !important`,
                border: `1px solid ${theme.tertiary} !important`,
            },
            [t.breakpoints.down('sm')]: {
                display: 'block',
            },
        },
        contactBtn: {
            backgroundColor: theme.primary,
            // color: theme.secondary,
            borderRadius: '0px !important',
            textTransform: 'inherit !important',
            textDecoration: 'none !important',
            width: '150px !important',
            height: '50px !important',
            fontSize: '1rem !important',
            fontWeight: '500 !important',
            fontFamily: 'var(--primaryFont) !important',
            border: `1px solid ${theme.fourthly} !important`,
             transition: '250ms ease-in-out',
            '&:hover': {
                transform: 'scale(1.05)',
                backgroundColor: `theme.tertiary !important`,
                color: `theme.primary !important`,
                border: `1px solid ${theme.tertiary} !important`,
            },
            [t.breakpoints.down('sm')]: {
                display: 'block',
            },
        },
    }));

    const classes = useStyles();

    return (
        <div className='landing'>
            <div className='landing--container'>
                <div className='landing--container-left'>
                    <div className='landing-left-content'>
                        &nbsp;
                    </div>
                </div>
                 <img
                    src={headerData.image2}
                    alt=''
                    className='landing--img'
                    style={{
                        opacity: `${drawerOpen ? '0' : '1'}`
                    }}
                />
                <div
                    className='landing--container-right'>
                        <div
                            className='landing-right-content'
                            style={{textAlign:'left'
                            }}
                        >
                        <div className='headerTitle'>
                            <span >{headerData.prefix}</span>
                            <span className='headerTitle' style={{color:theme.tertiary,backgroundColor:theme.secondary}}>
                                <TypeAnimation
                                sequence={[
                                    // Same substring at the start will only be typed out once, initially
                                    headerData.title,
                                    500, // wait 1s before replacing "Mice" with "Hamsters"
                                    headerData.title1,
                                    500,
                                    headerData.title2,
                                    500,
                                    headerData.title3,
                                    500
                                ]}
                                // style={{ fontFamily: 'Monoton' }}
                                wrapper="span"
                                speed={50}
                                repeat={0}
                                />
                            </span>
                        </div>
                        <br></br>
                        <h4>{headerData.target}</h4>
                        <p>{headerData.description}</p>

                        <div className='landing-buttonContainer'>
                            {headerData.resumePdf && (
                                <a
                                    href={headerData.resumePdf}
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    <Button className={classes.resumeBtn}>
                                        Mon CV
                                    </Button>
                                </a>
                            )}
                            <NavLink
                                to='/#contacts'
                                smooth={true}
                                spy='true'
                                duration={2000}
                            >
                                <Button className={classes.contactBtn}>
                                    Contact
                                </Button>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Landing;
